import AssuranceRatingSection from './AssuranceRatingSection';
import EligibilityStepsSection from './EligibilityStepsSection';

/**
 * Presentational body for the Eligibility Setup screen — the scrollable content
 * shared by the Settings tab and the onboarding wizard adapter. Footer / save
 * controls are owned by the consumer.
 */
const EligibilitySetupBody = ({ draft, onThresholdChange, onStepsChange }) => (
  <div className="flex w-full flex-1 flex-col items-center overflow-y-auto">
    <div className="flex w-full max-w-[770px] flex-col gap-7 px-4 py-6">
      <AssuranceRatingSection
        value={draft.assurance_thresholds?.auto_finalize_gfe}
        onChange={onThresholdChange}
      />
      <div className="h-[1px] w-full bg-neutral-200" />
      <EligibilityStepsSection steps={draft.steps} onChange={onStepsChange} />
    </div>
  </div>
);

export default EligibilitySetupBody;
